// extracted by mini-css-extract-plugin
export var form = "_bu-0";